export const RHDHVLockedForEditingMessage = 'components.sidebar.Tabs.CommentsTab.royalHaskoningMSG'
export const EcoMovementLockedForEditingMessage = 'components.sidebar.Tabs.CommentsTab.ecomovementMSG'

export const RHDHVBedrijventerreinenLockedForEditingMessage = 'components.sidebar.Tabs.CommentsTab.goralMSG'
